import { Button, Container, FormControl, Typography } from "@mui/material";
import InputFormik from "../components/inputs/InputFormik";
import TextareaFormik from "../components/inputs/TextareaFormik";
import useSupportFormik from "../hooks/useSupportHook";

export default function SupportRoute() {
  const {
    values,
    loading,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useSupportFormik();

  return (
    <Container
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: {
          xs: "100%",
          sm: "100%",
          md: "75%",
          lg: "75%",
        },
        padding: 4,
        justifyContent: "center",
        gap: 1,
      }}
    >
      <img
        style={{ margin: ".25rem auto", width: 250 }}
        alt="logo"
        src={"/logo.png"}
      />
      <Typography
        sx={{
          color: (theme) => theme.palette.text.primary,
          fontWeight: 900,
          fontSize: {
            xs: 20,
            sm: 20,
            md: 25,
            lg: 25,
          },
          textAlign: "center",
          marginBottom: 2,
        }}
      >
        Reportar un problema
      </Typography>
      <Typography
        sx={{
          color: (theme) => theme.palette.text.secondary,
          fontSize: {
            xs: 14,
            sm: 14,
            md: 16,
            lg: 16,
          },
          textAlign: "center",
          marginBottom: 3,
        }}
      >
        Por favor, completa el formulario a continuación y nos pondremos en contacto contigo lo antes posible.
      </Typography>
      <FormControl
        sx={{
          width: {
            xs: "100%",
            sm: "80%",
            md: "60%",
            lg: "40%",
          },
          mx: "auto",
          gap: 2,
        }}
      >
        <InputFormik
          label="Nombre"
          name="name"
          value={values.name}
          error={!!touched.name && !!errors.name}
          errorText={errors.name ?? ""}
          handleChange={handleChange("name")}
          handleBlur={handleBlur("name")}
          type="text"
        />

        <InputFormik
          label="Correo electrónico"
          name="email"
          value={values.email}
          error={!!touched.email && !!errors.email}
          errorText={errors.email ?? ""}
          handleChange={handleChange("email")}
          handleBlur={handleBlur("email")}
          type="email"
          autoCapitalize="none"
        />

        <InputFormik
          label="Asunto"
          name="subject"          
          value={values.subject}
          error={!!touched.subject && !!errors.subject}
          errorText={errors.subject ?? ""}
          handleChange={handleChange("subject")}
          handleBlur={handleBlur("subject")}
          type="text"
          disabled={true}
        />

        <TextareaFormik
          label="Descripción del problema"
          name="message"
          value={values.message}
          error={!!touched.message && !!errors.message}
          errorText={errors.message ?? ""}
          handleChange={handleChange("message")}
          handleBlur={handleBlur("message")}
          rows={6}
          placeholder="Describe el problema o consulta que deseas reportar..."
        />

        <Button
          variant="contained"
          onClick={(e: any) => handleSubmit(e)}
          disabled={loading}
          sx={{
            fontWeight: 900,
            borderRadius: 10,
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.primary.dark,
            },
          }}
        >
          {loading ? "Enviando..." : "Enviar reporte"}
        </Button>
      </FormControl>
    </Container>
  );
}

